import { BROWSER_NOTIFY, BROWSER_TAB_VISIBLE_ACTIVITY, LOCAL_STROAGE_CHANGES } from './Constants';

export const browserNotifyAction = (pageName) => {
    return {
        type: BROWSER_NOTIFY,
        payload:{
            pageName
        }
    }
}

/**
 * Hanlde the browser tab activities
 * @param {Bool} isVisible
 */
export const browserTabAction = (isVisible) => {
    return {
        type: BROWSER_TAB_VISIBLE_ACTIVITY,
        payload:{
            isVisible
        }
    }
}

export const webSettingLocalAction = (data) => {
    return {
        type: LOCAL_STROAGE_CHANGES,
        payload:{
            data
        }
    }
}

